import React from "react";
import { SegmentView } from "@tiny/api";
import { Typography } from "@tiny/components";
import { formatNumber } from "@tiny/components/src/utils/formatUtils";

interface SegmentItemDetailsProps {
  item: SegmentView;
}

function SegmentItemDetails(props: SegmentItemDetailsProps) {
  const { item } = props;

  return (
    <div>
      <Typography variant="body2" color="grey" tone={900} display="block">
        {formatNumber(item.numberOfCustomers)}
      </Typography>
      <Typography variant="label3" color="grey" tone={600}>
        Customers
      </Typography>
    </div>
  );
}

export default SegmentItemDetails;
